var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 5,
    viewBox: "0 0 8 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.01989 0.979821C7.21516 1.17508 7.21516 1.49167 7.01989 1.68693L4.35323 4.35359C4.15797 4.54886 3.84138 4.54886 3.64612 4.35359L0.979454 1.68693C0.784192 1.49167 0.784192 1.17508 0.979454 0.979821C1.17472 0.784559 1.4913 0.784559 1.68656 0.979821L3.99967 3.29293L6.31279 0.979821C6.50805 0.784558 6.82463 0.784558 7.01989 0.979821Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronWhite);
export default __webpack_public_path__ + "static/media/chevronWhite.ac82cf6b30c2b18f9f74a46f314ababe.svg";
export { ForwardRef as ReactComponent };